import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "lifecycle-data"
    }}>{`Lifecycle data`}</h1>
    <p>{`When used with the `}<a parentName="p" {...{
        "href": "../../../../solution/adobe-analytics/index.md"
      }}>{`Analytics extension`}</a>{`, this data is collected and sent to Analytics on every session start. Sessions are determined by the `}<a parentName="p" {...{
        "href": "./configuration-keys.md#lifecyclesessiontimeout"
      }}>{`sessionTimeout`}</a>{` configuration.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`This data is not used with Lifecycle for Edge Network. Instead, view the `}<a parentName="p" {...{
        "href": "../../../../edge/lifecycle-for-edge-network/metrics.md"
      }}>{`Lifecycle for Edge Network data`}</a>{` reference.`}</p>
    <h2 {...{
      "id": "lifecycle-data-content-response-data"
    }}>{`Lifecycle data content response data`}</h2>
    <p>{`The following data is collected on each `}<a parentName="p" {...{
        "href": "./event-reference.md#lifecycle-data-content-response"
      }}>{`Lifecycle data content response`}</a>{` event.`}</p>
    <h3 {...{
      "id": "install"
    }}>{`Install`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Data`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`First Launches`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.InstallEvent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Triggered at the first run after installation or re-installation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Install Date`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.InstallDate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Date of first launch after installation. The format is `}<inlineCode parentName="td">{`M/d/yyyy`}</inlineCode>{`, and an example is `}<inlineCode parentName="td">{`5/3/2017`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "upgrade"
    }}>{`Upgrade`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Data`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Upgrades`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.UpgradeEvent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Triggered at the first run after upgrade or when the version number changes.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Days since last upgrade`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.DaysSinceLastUpgrade`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of days since the application version number changed. `}<br /><br />{` `}<strong parentName="td">{`Important`}</strong>{`: This data is `}<strong parentName="td">{`not`}</strong>{` automatically stored in an Analytics metric. You must create a processing rule that sets a custom event to capture this data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Launches since last upgrade`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.LaunchesSinceUpgrade`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of launches since the application version number changed. `}<br /><br />{` `}<strong parentName="td">{`Important`}</strong>{`: This data is `}<strong parentName="td">{`not`}</strong>{` automatically stored in an Analytics metric. You must create a processing rule that sets a custom event to capture this data.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "launch"
    }}>{`Launch`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Data`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Daily Engaged Users`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.DailyEngUserEvent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Triggered when the application is used on a particular day.`}<br /><br />{` `}<strong parentName="td">{`Important`}</strong>{`: This data is `}<strong parentName="td">{`not`}</strong>{` automatically stored in an Analytics metric. You must create a processing rule that sets a custom event to capture this data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Monthly Engaged Users`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.MonthlyEngUserEvent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Triggered when the application is used during a particular month.`}<br /><br />{` `}<strong parentName="td">{`Important`}</strong>{`: This data is `}<strong parentName="td">{`not`}</strong>{` automatically stored in an Analytics metric. You must create a processing rule that sets a custom event to capture this data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Launches`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.LaunchEvent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Triggered on every run, including crashes and installs. Also triggered when the app is resumed from the background after the lifecycle session timeout is exceeded.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Previous Session Length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.PrevSessionLength`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Reports the number of seconds that a previous application session lasted based on how long the application was open and in the foreground.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Ignored Session Length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.ignoredSessionLength`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`If the last session is set to last longer than `}<inlineCode parentName="td">{`lifecycle.sessionTimeout`}</inlineCode>{`, that session length is ignored and recorded here.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Launch Number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.Launches`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of times the application was launched or brought out of the background.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Days since first use`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.DaysSinceFirstUse`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of days since first run.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Days since last use`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.DaysSinceLastUse`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of days since last use.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hour of Day`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.HourOfDay`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Measures the hour the app was launched and uses the 24-hour numerical format. Used for time parting to determine peak usage times.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Day of Week`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.DayOfWeek`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Measures the day of the week the app was launched.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "crash"
    }}>{`Crash`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Data`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Crashes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.CrashEvent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Triggered when the application crashed before closing. The event is sent when the application is started again after the crash.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "device-information"
    }}>{`Device information`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Data`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`App ID`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.AppId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Stores the application name and version in the following format: `}<inlineCode parentName="td">{`AppName BundleVersion (app version code)`}</inlineCode>{`. An example of this format is `}<inlineCode parentName="td">{`MyAppName 1.1(1)`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Device name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.DeviceName`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Store the device name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Operating system version`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.OSVersion`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Stores the operating system's name and version.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Carrier name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.CarrierName`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Stores the name of the mobile service provider as provided by the device. `}<br /><br />{` `}<strong parentName="td">{`Important:`}</strong>{` This data is `}<strong parentName="td">{`not`}</strong>{` automatically stored in an Analytics variable. You must create a processing rule to copy this value to an Analytics variable for reporting.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Resolution`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.Resolution`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The width x height in pixels.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Locale`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.locale`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The locale set for the application. For example, `}<inlineCode parentName="td">{`en-US`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`System Locale`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`a.systemLocale`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The locale set for this device. For example, `}<inlineCode parentName="td">{`en-US`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      